import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  past: [],
  present: null, // Tek bir transaction obje (array değil)
  future: [],
};

// Bellek koruması: `past` her action'da büyüyor (bilgi-amaçlı log; gerçek undo
// ChronoUndoRedoManager'da). Sınırsız büyüme oturum boyu belleği şişiriyordu →
// en eski kayıtları at, son MAX_PAST kadarını tut.
const MAX_PAST = 200;
function capPast(state) {
  if (state.past.length > MAX_PAST) {
    state.past.splice(0, state.past.length - MAX_PAST);
  }
}

const operationHistorySlice = createSlice({
  name: 'operationHistory',
  initialState,
  reducers: {
    addAction: (state, action) => {
      // Transaction-based: present'i past'e kaydet, yeni action'ı present yap
      if (state.present !== null) {
        state.past.push(state.present);
      }

      state.present = {
        type: action.payload.type || 'ACTION',
        label: action.payload.label || action.payload.description || 'Unnamed Action',
        timestamp: action.payload.timestamp || Date.now(),
        id: action.payload.id,
      };

      state.future = [];
      capPast(state);
    },

    // ✅ Toplu action ekleme (performans için)
    addActions: (state, action) => {
      const actions = action.payload; // Array of actions
      if (!Array.isArray(actions) || actions.length === 0) return;

      // İlk action hariç diğerlerini past'e ekle
      if (state.present !== null) {
        state.past.push(state.present);
      }

      // Tüm action'ları past'e ekle (son hariç)
      for (let i = 0; i < actions.length - 1; i++) {
        state.past.push(actions[i]);
      }

      // Son action present olur
      state.present = actions[actions.length - 1];
      state.future = [];
      capPast(state);
    },
      
    undoAction: (state) => {
      // Present yoksa undo edilecek bir şey yok
      if (!state.present) return;

      // Present'i future'a ekle
      state.future.unshift(state.present);

      // Past'ten bir önceki state'i al (yoksa null)
      state.present = state.past.length > 0 ? state.past.pop() : null;
    },
    redoAction: (state) => {
      if (state.future.length === 0) return;
      const next = state.future.shift();
      if (state.present) state.past.push(state.present);
      state.present = next;
      capPast(state);
    },
        addTransaction: (state, action) => {
      if (state.present !== null) state.past.push(state.present);
      state.present = action.payload;   // payload: { description, commands: [...] }
      state.future = [];
      capPast(state);
    },
    undoTransaction: (state, action) => {
      if (!state.present) return;
      state.future.unshift(state.present);
      state.present = state.past.length > 0 ? state.past.pop() : null;
    },
    redoTransaction: (state, action) => {
      if (state.future.length === 0) return;
      const next = state.future.shift();
      if (state.present) state.past.push(state.present);
      state.present = next;
      capPast(state);
    },
  },
});

export const { addAction, addActions, undoAction, redoAction,addTransaction, undoTransaction, redoTransaction } = operationHistorySlice.actions;
export default operationHistorySlice.reducer;